import { Component } from '@angular/core';

import { AbstractModal } from '../../../shared/components/modal/AbstractModal';
import { ModalService } from '../../../shared/components/modal/modal.service';

@Component({
  selector: 'ls-printers-help-modal',
  templateUrl: './printers-help-modal.component.html'
})
export class PrintersHelpModalComponent extends AbstractModal {
  constructor(private modal: ModalService) {
    super();
  }

  public close(): void {
    this.modal.close();
  }
}
